import { Badge } from "@material-ui/core";
import { CSSProperties } from "react";

interface RxCartIconProps {
	img: any;
	onClick?: () => void;
	style?: CSSProperties;
	badgeSize?: number;
	className?: string;
}

const RxCartIcon = (props: RxCartIconProps) => {
	return (
		<Badge
			badgeContent={props.badgeSize ?? 0}
			color="primary"
			anchorOrigin={{
				vertical: "top",
				horizontal: "right",
			}}
			overlap="circular"
		>
			<img
				alt="cart"
				src={props.img}
				className={props.className}
				onClick={props.onClick}
			/>
		</Badge>
	);
};

export default RxCartIcon;
